import React from 'react'
import { createRoot } from 'react-dom/client'
import { IntlProvider } from 'react-intl'
import { Provider } from 'react-redux'

import { initFeatureFlags } from 'utils/featureFlags'

import Typography from 'components/styles/Typography'

import RootContainer from './components/RootContainer'
import configureStore from './store'

import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file

import '@ironscales/design-system/styles'

const store = configureStore()

// Before render: the bundled manifest resolves synchronously, so no component
// ever sees an empty flag set. The live manifest fetch lands shortly after.
initFeatureFlags()

window.IRONSCALES = {}

const container = document.getElementById('app')
const root = createRoot(container)

async function bootstrap() {
  // MOCK=1 (pnpm start:mock): serve /members-api traffic from the
  // recorded MSW fixtures — no backend. The dynamic import keeps msw (a
  // devDependency) out of the regular bundle; with MOCK defined as '' the
  // whole branch is eliminated from prod builds.
  if (typeof MOCK !== 'undefined' && MOCK) {
    // Tenant selection order: an explicit window global wins (Storybook /
    // scripts), then a `mock-company` localStorage key (set it in devtools to
    // switch recorded tenants without a code edit — see src/mocks/README.md),
    // then the 'ofek' default.
    /* eslint-disable no-underscore-dangle */
    window.__MOCK_COMPANY__ =
      window.__MOCK_COMPANY__ || window.localStorage.getItem('mock-company') || 'ofek'
    /* eslint-enable no-underscore-dangle */
    // The ResolutionCenter list epic short-circuits to an in-repo demo list on
    // localhost; force the real request path so the recorded pairs serve it.
    window.localStorage.setItem('rc-list-mock', 'false')
    const { worker } = await import('./mocks/browser')
    await worker.start({ onUnhandledRequest: 'bypass', quiet: true })
  }

  const tree = (
    <>
      <Typography />
      <IntlProvider locale="en">
        <Provider store={store}>
          <RootContainer store={store} />
        </Provider>
      </IntlProvider>
    </>
  )

  // React 18 runs StrictMode's extra checks only in development. The wrapper
  // stays in the production bundle so dev and prod share one tree.
  root.render(<React.StrictMode>{tree}</React.StrictMode>)
}

bootstrap()
